import React from 'react';

function NotFound() {
  return (
    <div>Not found (404)</div>
  );
}

export default NotFound;